import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import FaLeftArr from 'react-icons/lib/fa/arrow-left'

class GenerateBackLink extends Component{
    render(){
        const {str, url, icon} = this.props
       
        return(
           <p className='backLink' style={{ float: 'right'}} >
               <a href={url} style={{ textDecoration: 'underline', paddingTop:'20px'}} 
                        className='btn btn-link'>
                    <span>{str}</span>
                </a>
                
                <a aria-label={str} href={url} style={{height: '50px',
                                width: '50px',
                                backgroundColor: '#007aff',
                                borderRadius: '50%',
                                display: 'inline-block',
                                marginRight:'10px',
                                color:'white',
                                textAlign:'center',
                                boxShadow:'4px 4px 8px #3c3d3d26'}}
                                >
                    {icon? icon: <FaLeftArr style={{marginTop:'15px', fontSize:'20px'}}/>}
                </a>
            </p>
       )
    }
}

export default GenerateBackLink


// WEBPACK FOOTER //
// ./src/components/GenerateBackLink.js